import React, { useEffect, useState } from 'react';
import TextFieldCS from './TextFieldCS';

const TablaGrid = (props) => {
  //HOOKS PÁGINA ACTUAL Y ELEMENTOS POR PÁGINA
  const [pagina, setPagina] = useState(1);
  const [elementosPorPagina, setElementosPorPagina ] = useState(10);

  //FUNCIÓN QUE MODIFICA LOS ELEMENTOS POR PÁGINA
  const cambiarElementosPorPagina = (event) => {
    const nuevoValor = parseInt(event.target.value);
    setElementosPorPagina(nuevoValor);
  };

  //OBTIENE LOS ÍNDICES ÚLTIMO Y PRIMERO
  const indiceInicial = (pagina - 1) * elementosPorPagina;
  const indiceFinal = indiceInicial + elementosPorPagina;

  //FILTRA Y MUESTRA SOLO LOS ELEMENTOS DE LA PÁGINA ACTUAL
  const elementosPagina = props.data.slice(indiceInicial, indiceFinal);

  //OBTIENE EL TOTAL DE PÁGINAS
  const totalPaginas = Math.ceil(props.data.length / elementosPorPagina);

  //FUNCIÓN QUE NAVEGA ENTGRE LAS PÁGINAS
  const cambiarPagina = (numeroPagina) => {
    setPagina(numeroPagina);
  };

  return (
    <div style={{overflow:'auto', backgroundColor: 'lightgray'}}>
      <table style={{borderBottom: '1px solid lightgray', width: '100%'}}>
        <thead style={{ position: 'sticky', top: -1, fontWeight: 'bold', textAlign: 'center' }}>
          <tr>
            {/* LOS ENCABEZADOS LOS ITERAMOS Y PONEMOS EL TITLE */}
            {props.columns.map((encabezado, index) => (
              <th key={index}>
                {encabezado.title}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {/* CREAMOS UNA FILA POR CADA OBJETO EN EL ARRAY DE DATOS */}
          {elementosPagina.map((objeto, index) => (
            <tr key={index}>

              {/* ITERAMOS DE NUEVO EL ENCABEZADO PORQUE INDICA LOS ESTILOS Y FORMATOS */}
              {props.columns.map((encabezado, index) => (

                // CREAMOS UNA CELDA POR CADA ENCABEZADO DENTRO DE LA FILA
                <td key={index} style={
                  //REVISAMOS SI EL ENCABEZADO TIENE ALGÚN ESTILO SEGÚN EL CONTENIDO DE LA CELDA
                  encabezado.cellStyle && encabezado.cellStyle(objeto[encabezado.field])
                  }>

                  {/* REVISAMOS SI EL ENCABEZADO TIENE UNA FUNCIÓN RENDER QUE FORMATEA EL CONTENIDO */}
                  {/* DE LO CONTRARIO PONEMOS EL CONTENIDO COMO VIENE */}
                  {
                    encabezado.render && encabezado.render(objeto)
                    ? encabezado.render(objeto)
                    :
                    objeto[encabezado.field]
                  }
              </td>
              ))}

            </tr>
          ))}

        </tbody>
      </table>

      {/* FOOTER CON OPCIONES */}
      <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '16px', backgroundColor: 'lightgray' }}>
        <div>
          <label htmlFor="elementosPorPagina">Elementos por página:</label> &nbsp;
          <select id="elementosPorPagina" value={elementosPorPagina} onChange={cambiarElementosPorPagina}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>

        <div style={{display: '-webkit-inline-box'}}>
          
          <button onClick={() => cambiarPagina(pagina - 1)} disabled={pagina === 1} style={{border: 'none', padding: '0', backgroundColor: 'inherit', color: '#0009'}}>
            ◄
          </button> 
          &nbsp;<p style={{padding: '0px 5px'}}>Página {pagina} de {totalPaginas}</p>&nbsp;
          <button onClick={() => cambiarPagina(pagina + 1)} disabled={indiceFinal >= props.data.length} style={{border: 'none', padding: '0', backgroundColor: 'inherit', color: '#0009'}}>
            ►
          </button>
        </div>

        <p>Mostrando {elementosPagina.length} de {props.data.length}</p>
        
      </div>

    </div>
  )
}


export default React.memo(TablaGrid);